export function getAdminAppUrl() {
  if (window.location.href.includes('localhost')) {
    return 'http://localhost:3000/'
  }
  return process.env.ADMIN_PANEL_URL || process.env.REACT_APP_ADMIN_PANEL_URL
}
